function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (val, type) {
  var tDefined = arguments.length >= 2;
  var tString = typeof type === 'string';
  var tFun = typeof type === 'function';
  var tUnd = typeof type === 'undefined';
  var vUnd = typeof val === 'undefined';
  var tNull = type === null;
  var vNull = val === null;
  var tArr = !tNull && _typeof(type) === 'object' && type.constructor.name === 'Array';
  var tReg = type && type.constructor.name === 'RegExp';
  var reg = /^\[object Arguments\]$/i;
  if (!tDefined) return false;
  if (tNull) return vNull;
  if (tUnd) return val === undefined;

  if (tFun) {
    if (vUnd || vNull) return false;
    return Object.getPrototypeOf(val).constructor.name === type.name;
  }

  if (tArr) {
    if (!type.length) return true;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = type[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var t = _step.value;
        if (t === null && vNull) return true;
        if (typeof t === 'undefined' && vUnd) return true;
        if (vNull || vUnd) continue;
        if (t === null || typeof t === 'undefined') continue;
        if (Object.getPrototypeOf(val).constructor.name === t.name) return true;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return false;
  }

  if (tString) {
    var t = type.toLowerCase().split('|');
    if (t.length === 1 && t[0] === '' || t.some(function (i) {
      return i === 'any';
    })) return true;
    if (t.some(function (i) {
      return i === 'truthy';
    }) && !!val) return true;
    if (t.some(function (i) {
      return i === 'falsy';
    }) && !val) return true;
    if (vUnd && t.some(function (i) {
      return i === 'undefined';
    })) return true;
    if (vNull && t.some(function (i) {
      return i === 'null';
    })) return true;
    if (vNull || val === undefined) return false;
    if (reg.test(val.toString()) && Object.getPrototypeOf(val).constructor.name === 'Object' && t.some(function (i) {
      return i === 'arguments';
    })) return true;
    return t.some(function (i) {
      return i === Object.getPrototypeOf(val).constructor.name.toLowerCase();
    });
  }

  if (tReg) {
    if (type.test('any') || type.test('')) return true;
    if (type.test('truthy') && !!val) return true;
    if (type.test('falsy') && !val) return true;
    if (type.test('undefined') && vUnd) return true;
    if (type.test('null') && vNull) return true;
    if (vNull || val === undefined) return false;
    if (type.test('arguments') && Object.getPrototypeOf(val).constructor.name === 'Object' && reg.test(val.toString())) return true;
    return type.test(Object.getPrototypeOf(val).constructor.name);
  }

  return false;
};